import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DurationPerClientFilter } from './duration-per-client-filter.model';
import { DurationPerWeekFilter } from './duration-per-week-filter.model';

export const DURATION_PER_MONTH_FILTER_SCHEMA = Object.freeze({
  MONTH: 0, // range [1, 12]
  CLIENTS: List<DurationPerClientFilter>([]),
  WEEKS: List<DurationPerWeekFilter>([]),
});
const RECORD = generateSchema(DURATION_PER_MONTH_FILTER_SCHEMA);
const KEYS: any = generateKeys(DURATION_PER_MONTH_FILTER_SCHEMA);

export class DurationPerMonthFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.CLIENTS,
        value: props.get(KEYS.CLIENTS)
          ? this.clients.map((params) => new DurationPerClientFilter(params))
          : List<DurationPerClientFilter>([]),
      },
      {
        key: KEYS.WEEKS,
        value: props.get(KEYS.WEEKS)
          ? this.weeks.map((params) => new DurationPerWeekFilter(params))
          : List<DurationPerWeekFilter>([]),
      },
    ]) as DurationPerMonthFilter;
  }

  get month(): number {
    return this.get(KEYS.MONTH);
  }

  get clients(): List<DurationPerClientFilter> {
    return this.get(KEYS.CLIENTS);
  }

  get weeks(): List<DurationPerWeekFilter> {
    return this.get(KEYS.WEEKS);
  }
}
